/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-29 10:49:23
 * @LastEditTime: 2021-02-24 19:21:03
 */
import request from '@/utils/request'

// 正在处理列表 未读消息
export function chatList(params) {
  return request({
    url: '/l_p/',
    method: 'get',
    params
  })
}

// 排队列表
export function queueList(params) {
  return request({
    url: '/l_w/',
    method: 'get',
    params
  })
}

// 获取用户基础信息
export function getUserDetail(params) {
  return request({
    url: '/u_i/',
    method: 'get',
    params
  })
}

// 客服发送消息
export function sendMsg(data) {
  return request({
    url: '/sh/',
    method: 'post',
    data
  })
}

// 接收消息
export function getChatMsg(params) {
  return request({
    url: '/sl/',
    method: 'get',
    params
  })
}

//  归档
export function closeMsg(data) {
  return request({
    url: '/c_s/',
    method: 'post',
    data
  })
}

// 上传文件
export function updateFile(data) {
  return request({
    url: '/f_u/',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 下载文件
export function downloadFile(params) {
  return request({
    url: '/f_d/',
    method: 'get',
    params
  })
}

// tags 列表
export function tagsList(params) {
  return request({
    url: '/b_i/',
    method: 'get',
    params
  })
}

// 修改tags
export function updateTag(data) {
  return request({
    url: '/m_t/',
    method: 'post',
    data
  })
}

// 获取报表信息
export function getReportData(params) {
  return request({
    url: '/o_r/',
    method: 'get',
    params
  })
}

// 修改快捷回复
export function quickReply(data) {
  return request({
    url: '/m_qr/',
    method: 'post',
    data
  })
}

// 拉取历史消息
export function getHistoryList(params) {
  return request({
    url: '/p_h/',
    method: 'get',
    params
  })
}

// ____________________0.3.0______________
// 所有包用户
export function getAllUsers(params) {
  return request({
    url: '/u_l/',
    method: 'get',
    params
  })
}

// 主动发起会话
export function launchChat(data) {
  return request({
    url: '/s_i/',
    method: 'post',
    data
  })
}

// 待分配列表
export function getDisList(params) {
  return request({
    url: '/all_w/',
    method: 'get',
    params
  })
}

// 分配给自己会话
export function getChatToOur(params) {
  return request({
    url: '/as_m/',
    method: 'get',
    params
  })
}

// 移除会话
export function removeChat(params) {
  return request({
    url: '/r_m/',
    method: 'get',
    params
  })
}

// 批量发送消息
export function batchSendMsgs(data) {
  return request({
    url: '/b_s/',
    method: 'post',
    data
  })
}

// 客服添加tag
export function addTag(data) {
  return request({
    url: '/c_a_t/',
    method: 'post',
    data
  })
}

// 客服获取自动回复列表
export function getAutoReplyList(params) {
  return request({
    url: '/ar_l/',
    method: 'get',
    params
  })
}

// 客服更新自己的用户分组
export function updateSug(data) {
  return request({
    url: '/s_u_g/',
    method: 'post',
    data
  })
}

// 客服更新自动回复列表
export function updateAutoReply(data) {
  return request({
    url: '/ar_m/',
    method: 'post',
    data
  })
}

// 客服获取订单信息
export function getOrderInfo(params) {
  return request({
    url: '/g_b/',
    method: 'get',
    params
  })
}

// 客服操作时间
export function timeOpp(data) {
  return request({
    url: '/opp/',
    method: 'post',
    data
  })
}